/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RelationshipTypeEnum } from './RelationshipTypeEnum';
import {
    RelationshipTypeEnumFromJSON,
    RelationshipTypeEnumFromJSONTyped,
    RelationshipTypeEnumToJSON,
    RelationshipTypeEnumToJSONTyped,
} from './RelationshipTypeEnum';

/**
 * 
 * @export
 * @interface RelatedCaseUpdate
 */
export interface RelatedCaseUpdate {
    /**
     * 
     * @type {number}
     * @memberof RelatedCaseUpdate
     */
    relatedProsecutionId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RelatedCaseUpdate
     */
    title?: string | null;
    /**
     * 
     * @type {RelationshipTypeEnum}
     * @memberof RelatedCaseUpdate
     */
    relationshipType?: RelationshipTypeEnum | null;
}



/**
 * Check if a given object implements the RelatedCaseUpdate interface.
 */
export function instanceOfRelatedCaseUpdate(value: object): value is RelatedCaseUpdate {
    return true;
}

export function RelatedCaseUpdateFromJSON(json: any): RelatedCaseUpdate {
    return RelatedCaseUpdateFromJSONTyped(json, false);
}

export function RelatedCaseUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): RelatedCaseUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'relatedProsecutionId': json['related_prosecution_id'] == null ? undefined : json['related_prosecution_id'],
        'title': json['title'] == null ? undefined : json['title'],
        'relationshipType': json['relationship_type'] == null ? undefined : RelationshipTypeEnumFromJSON(json['relationship_type']),
    };
}

export function RelatedCaseUpdateToJSON(json: any): RelatedCaseUpdate {
    return RelatedCaseUpdateToJSONTyped(json, false);
}

export function RelatedCaseUpdateToJSONTyped(value?: RelatedCaseUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'related_prosecution_id': value['relatedProsecutionId'],
        'title': value['title'],
        'relationship_type': RelationshipTypeEnumToJSON(value['relationshipType']),
    };
}

